import React, { Component } from 'react';
import { ICONS, PATHS, IntroContent, USER_ROLES } from '../../common/constants';
import Actions from '../Actions';
import AssetForm from '../AssetForm';
import Button from '../Button';
import Empty from '../Empty';
import Icon from '../Icon';
import Overlay from '../Overlay';
import Search from '../Search';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setAssetFormData, clearAssetFormData } from '../../store/actions/assetForm';
import { selectSearch } from '../../store/selectors/search';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import Loader from '../Loader';
import { selectFormLoader } from '../../store/selectors/FormLoader';
import Row from '../Row';
import Document from '../Document';
import Col from '../Col';
import { groupBy } from 'lodash';
import AreaDocument from './AreaDocument';
import './AreaDocument.scss';
import { selectAssetFormData } from '../../store/selectors/assetForm';
// import variables from '../../styles/includes/variables.scss';

import { variables } from '../../Tenants';
import ContentBlock from '../ContentBlock';

class AreaAssetsTable extends Component {
  state = {
    showOverlay: false,
    formData: {
      item_id: '',
      serial_number: '',
      room: '',
      dateOfPurchase: null
    },
    initialFormData: {
      item_id: '',
      serial_number: '',
      room: '',
      dateOfPurchase: null
    },
    viewAsset: ''
  };
  componentDidMount () {
    this.openFirstRoom();
  }
  openFirstRoom = () => {
    const { assets  } = this.props;
    if(assets && assets.length > 0) {
    this.setState({ viewAsset: assets[0].name, viewAssetId: assets[0].areaId});
    }
  }
  componentDidUpdate (preProps) { 
    const { search,assets } = this.props;
    // if(search.assets) {
    //   if(preProps.assets !== this.props.assets && preProps.search.assets !== this.props.search.assets) {
    //     this.openFirstRoom()
    //   }
    // } else {
    //   if(preProps.assets !== this.props.assets) {
    //     this.openFirstRoom()
    //   }
    // }
    if(preProps.assets.length < assets.length ){
      this.setState({ viewAsset: this.state.viewAsset === assets[0].name ? '' : assets[0].name, viewAssetId: this.state.viewAssetId === assets[0].areaId ? '' : assets[0].areaId});
    }
  }

  
  renderAsset(asset, x) {
    
    const { onDeleteAsset, suite, property, setAssetFormData,user } = this.props;
    const { viewAssetId } = this.state;
    // console.log('asset.item.itemTypeIcons.name --->',asset.item.itemTypeIcons && asset.item.itemTypeIcons.name ? asset.item.itemTypeIcons.name : asset.item)
    return (
    //   <Col
    //   key={x}
    //   xs="5"
    // >
    <>
      {asset.item !== null  ? <div className='areadocuments__body'>
        <AreaDocument
          user={user}
          onDelete={ e => window.confirm(`Are you sure you want to delete ${asset.item.name}?`)&&onDeleteAsset(viewAssetId,asset.id)}
          headline={asset.item && asset.item.name ? asset.item.name : ''}
          edit={true}
           onView={() => {
            this.props.history.push({
              pathname:PATHS.ASSETS_VIEW.replace(':id', viewAssetId+'&'+asset.id),
             state:{ asset:asset,suite:this.props.suite,property:this.props.property }
            })
          }}
          // strapline={asset.item.makeName + " " + asset.item.model}
          onEdit={() => {
                setAssetFormData({...asset,areaId:this.state.viewAssetId, assetWarrantyDefaultStartDate: suite.assetWarrantyDefaultStartDate})
              this.setState({ showOverlay: true, newAsset: false})}}
          icon={(
            <Icon
              glyph={ICONS[asset.item && asset.item.itemTypeIcons && asset.item.itemTypeIcons.name ? asset.item.itemTypeIcons.name : '']}
              weight="light"
            />
          )}
        />
        </div> : null}
        </>
      // </Col>
    )
  }
  searchAssets(asset, x) {
      return (
        <>
          { this.renderAsset(asset, x)}
        </>
      )
  }
  renderRoomsAndAssets(rooms, room) {
    const { viewAsset } = this.state;
    const {assetFormData } = this.props;
    const filterRooms = rooms.filter( a => a.item !== null);
   if(filterRooms.length >0){
    rooms=[...new Map(filterRooms.map(item => [item.item.name, item])).values()];
   }
    if (viewAsset === room) {
      return (
        <>
          {rooms.map((asset, x) =>
          (
            <>
              { this.searchAssets(asset, x)}
            </>
          )
          )}
        </>
      )
    }
  }
  expandRoom(room) {
      this.setState({ viewAsset: this.state.viewAsset === room.name ? '' : room.name, viewAssetId: this.state.viewAssetId === room.areaId ? '' : room.areaId});
  }
  render() {
    const { assets, loader, onSaveAsset,setAssetFormData, clearAssetFormData, onSearch, search, user, suite, introContent } = this.props;
    const { showOverlay } = this.state;
    let homeOwnerCheck = user && user.roles && user.roles.length > 0 && (user.roles[0].role.name === 'Home Owner' || user.roles[0].role.name === 'Occupant' || user.roles[0].role.name === "Strata Manager" || user.roles[0].role.name === "Realtor") ? true : false;
    // const rooms = groupBy(assets, a => a.customLabel ? a.customLabel : a.roomType)
    // console.log('assets --->',assets);
    return (
      <>
        {loader ? <Loader center={true}/> : null}
        {/**
          * Created By: Sai Prasad
          * Created Date: 29/09/2022
          * Jira Ticket: JUN-3214
          * Description: Intro content to Assets Tab under suite.
        */}
        {introContent &&
          <ContentBlock content={IntroContent.rooms}/>}
        <Actions compact>
          <Search
            size="small"
            placeholder="Search Assets..."
            onChange={onSearch}
          />
          {homeOwnerCheck ?
          null
         : <Button
            color="teal"
            label="Add Asset"
            onClick={() => {setAssetFormData({
             assetWarrantyDefaultStartDate: suite && suite.assetWarrantyDefaultStartDate ? suite.assetWarrantyDefaultStartDate : null,
              dateOfPurchase: suite && suite.assetWarrantyDefaultStartDate ? suite.assetWarrantyDefaultStartDate : null
            });this.setState({ showOverlay: true, formData: this.state.initialFormData, newAsset: true })}}
            icon={(
              <Icon
                glyph="boxes"
                weight="light"
                size="small"
              />
            )}
            size="small"
          />
            }
        </Actions>
        {assets.length > 0 ? (
          <div style={{paddingTop: 15}}>
          {assets.map(room => {
              return (
                <div key={room.name}>
                  <div
                    style={{ display: 'flex', textAlign: 'center', cursor: 'pointer', marginLeft: 10, marginRight: 10 }}
                    onClick={ () => 
                    this.expandRoom(room)
                    }
                  >
                    <div
                      className="service-request-from-asset__title"
                      style={{cursor:'pointer', marginRight: 20}}
                    >
                      {room.customLabel ? room.customLabel : room.name}
                    </div>
                    <div style={{justifyContent: 'center', alignItems: 'center', paddingTop: 1}}>
                    <Icon
                      glyph={this.state.viewAsset === room.name ? 'chevron-up' : 'chevron-down'}
                      weight="regular"
                    />
                    </div>
                  </div>
                  <Row style={{marginLeft:'0px', marginRight:'0px'}}>
                    { this.renderRoomsAndAssets(room.assets,room.name) }
                    </Row>
                </div>
              )})}
          </div>
        ) : (
          <Empty
            headline={"This "+variables.suite+" is empty"}
            strapline={"Add assets to this "+variables.suite+" and attach relevant documentation such as manuals and warranties."}
            searchIsActive={search && search.assets ? search.assets : ''}
            cta={(
              homeOwnerCheck ? null
             : <Button
                color="teal"
                label="Add Asset"
                onClick={() => {
                  setAssetFormData({
                    assetWarrantyDefaultStartDate: suite && suite.assetWarrantyDefaultStartDate ? suite.assetWarrantyDefaultStartDate : null,
                    dateOfPurchase: suite && suite.assetWarrantyDefaultStartDate ? suite.assetWarrantyDefaultStartDate : null
                  });
                  this.setState({ showOverlay: true, formData: this.state.initialFormData, newAsset: true })}}
                icon={(
                  <Icon
                    glyph="boxes"
                    weight="light"
                    size="small"
                  />
                )}
                size="small"
              />
            )}
            image={(
              <img
                src="/assets/empty/assets.svg"
                alt={`This ${variables.suite} is empty`}
              />
            )}
          />
        )}
        <Overlay
          showOverlay={showOverlay}
          content={(
            <AssetForm
            newAsset={this.state.newAsset}
            suiteId={this.props.suite.id}
            propertyId={this.props.suite.propertyId}
            onClose={() => {
              this.setState({ showOverlay: false },() => clearAssetFormData())}}
              onSaveAsset={onSaveAsset}
            />
          )}
        />
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  search: selectSearch(state),
  user: selectAuthenticatedUser(state),
  loader: selectFormLoader(state),
  assetFormData: selectAssetFormData(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({
  setAssetFormData,
  clearAssetFormData
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AreaAssetsTable);
